import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BooksPage = lazy(() => import('../pages/books/page'));
const ArtworkPage = lazy(() => import('../pages/artwork/page'));
const AudiobooksPage = lazy(() => import('../pages/audiobooks/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/books',
    element: <BooksPage />,
  },
  {
    path: '/artwork',
    element: <ArtworkPage />,
  },
  {
    path: '/audiobooks',
    element: <AudiobooksPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
